module.exports = __webpack_public_path__ + "img/3.4597039d.webp";